// extracted by mini-css-extract-plugin
export default {"root":"SurfaceBody_root__kAGM6"};